import React from "react";
import Skeleton from '@mui/material/Skeleton';

export const TextSkeleton = props => {
	return (
		<Skeleton variant="text" animation="wave" {...props} />
	);
}